import { writable } from "svelte/store";
import { searchHistoryStore } from "./searchHistoryStore";

const DEFAULT_CRITERIA = [""];

interface SearchFormState {
  isVisible: boolean;
  query: string;
  criteria: string[];
}

function createSearchFormStore() {
  const { subscribe, update } = writable<SearchFormState>({
    isVisible: false,
    query: "",
    criteria: [...DEFAULT_CRITERIA],
  });

  return {
    subscribe,
    show(queryText?: string, newCriteria?: string[]) {
      update((state) => ({
        ...state,
        isVisible: true,
        query: queryText ?? searchHistoryStore.getLatestSearch()?.query ?? "",
        criteria: newCriteria ?? state.criteria,
      }));
      overlaySearchQuery.set(queryText ?? searchHistoryStore.getLatestSearch()?.query ?? "");
    },

    hide() {
      update((state) => ({
        ...state,
        isVisible: false,
        query: "",
        criteria: [],
      }));
    },

    toggle() {
      update((state) => ({
        ...state,
        isVisible: !state.isVisible,
        query: state.isVisible ? "" : (searchHistoryStore.getLatestSearch()?.query ?? ""),
      }));
    },

    addCriterion(criterion: string) {
      update((state) => ({
        ...state,
        criteria: [...state.criteria, criterion],
      }));
    },

    removeCriterion(criterion: string) {
      update((state) => ({
        ...state,
        criteria: state.criteria.filter((c) => c !== criterion),
      }));
    },

    resetCriteria() {
      update((state) => ({
        ...state,
        criteria: [...DEFAULT_CRITERIA],
      }));
    },

    setCriteria(criteria: string[]) {
      update((state) => ({
        ...state,
        criteria: [...criteria],
      }));
    },
  };
}

export const searchFormOverlayStore = createSearchFormStore();
export const showSearchFormOverlay = { subscribe: searchFormOverlayStore.subscribe };
export const overlaySearchQuery = writable("");
